module.exports = __webpack_public_path__ + "static/img/30005 (2).8c6a5b1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30005 (2).webp
// module id = kbIu
// module chunks = 14